import A11yMenu from './_a11yMenu';
import Swiper from 'swiper';
import {
	Pagination, A11y,
} from 'swiper/modules';

const initMultiBlocksSlider = () => {
	const sliders = document.querySelectorAll('.multiblocks-swiper');
	sliders.forEach((elt) => {
		const nbCols = elt.getAttribute('data-tabCols');
		const swiper = new Swiper(elt, {
			modules: [Pagination, A11y],
			slidesPerView: 1,
			spaceBetween: 36,
			enabled: true,
			autoHeight: true,
			init: false,
			watchOverflow: false,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				bulletElement: 'button',
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					enabled: true,
				},
				720: {
					slidesPerView: nbCols,
					enabled: true,
				},
				960: {
					enabled: false,
				},
			},
		});

		swiper.on('breakpoint', (swipe, breakpointParams) => {
			if (!breakpointParams.enabled) {
				swipe.el.classList.add('disabled');
			} else {
				swipe.el.classList.remove('disabled');
			}
		});
		swiper.init();
	});
};

document.addEventListener('DOMContentLoaded', () => {
	const menu = new A11yMenu(document.querySelector('.a11y-nav-block'), '50rem');
	menu.menuSetup();

	initMultiBlocksSlider();
});
